export const FETCH_BRAND_REQUEST = 'FETCH_BRAND_REQUEST';
export const FETCH_BRAND_SUCCESS = 'FETCH_BRAND_SUCCESS';
export const FETCH_BRAND_FAILURE = 'FETCH_BRAND_FAILURE';

export const FETCH_ALL_BRANDS_REQUEST = 'FETCH_ALL_BRANDS_REQUEST';
export const FETCH_ALL_BRANDS_SUCCESS = 'FETCH_ALL_BRANDS_SUCCESS';
export const FETCH_ALL_BRANDS_FAILURE = 'FETCH_ALL_BRANDS_FAILURE';

export const FETCH_BRANDS_BY_DEALER_REQUEST = 'FETCH_BRANDS_BY_DEALER_REQUEST';
export const FETCH_BRANDS_BY_DEALER_SUCCESS = 'FETCH_BRANDS_BY_DEALER_SUCCESS';
export const FETCH_BRANDS_BY_DEALER_FAILURE = 'FETCH_BRANDS_BY_DEALER_FAILURE';

export const FETCH_BRANDS_BY_GROUP_REQUEST = 'FETCH_BRANDS_BY_GROUP_REQUEST';
export const FETCH_BRANDS_BY_GROUP_SUCCESS = 'FETCH_BRANDS_BY_GROUP_SUCCESS';
export const FETCH_BRANDS_BY_GROUP_FAILURE = 'FETCH_BRANDS_BY_GROUP_FAILURE';
